import { render, staticRenderFns } from "./List-registro-vacinacao.vue?vue&type=template&id=a52b6de2&scoped=true&"
import script from "./List-registro-vacinacao.vue?vue&type=script&lang=js&"
export * from "./List-registro-vacinacao.vue?vue&type=script&lang=js&"
import style0 from "./List-registro-vacinacao.vue?vue&type=style&index=0&id=a52b6de2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a52b6de2",
  null
  
)

export default component.exports